import {
  CrmEndpoint,
  CrmEndpointListResponse,
  CrmEndpointParams,
  CrmEndpointRequestOptions,
} from '@touch4it/ng-swp/endpoint';
import { map, Observable } from 'rxjs';
import { CrmDictionary } from '@touch4it/ng-swp/core/types';

import { EndpointListRequest } from './endpoint-list.request';
import { EndpointListResponse } from './endpoint-list.response';
import { EndpointResponseTransformer } from './endpoint-response.transformer';

export class Endpoint<T extends { id: unknown }> extends CrmEndpoint<T> {
  constructor(params: CrmEndpointParams<T>) {
    super({
      ...params,
      responseTransformer: new EndpointResponseTransformer<T>(),
    });
  }

  aspList(options?: CrmEndpointRequestOptions<EndpointListRequest>): Observable<CrmEndpointListResponse<T>> {
    const { pathParams, ...rest } = options ?? {};

    const endpoint = this.endpoint({ pathParams });
    const reqOptions = this.getReqOptions(rest);

    return this.client.get<EndpointListResponse<T>>(endpoint, reqOptions).pipe(
      map((response) => ({
        skip: response.offset,
        limit: response.pageSize,
        total: response.totalItems,
        data: response.items.map(this.responseTransformer.transform),
      })),
    );
  }

  aspDelete(id: string, options?: CrmEndpointRequestOptions<CrmDictionary>): Observable<void> {
    const { pathParams, ...rest } = options ?? {};

    return this.client.delete<void>(`${this.endpoint({ pathParams })}/${id}`, this.getReqOptions(rest));
  }
}
